if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"pflm_statistics","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(186|445|598|689|71|843)$/.test(chunkId)},
		rootOutputDir: "../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}